class ProductButtons extends HTMLElement {
  constructor(){
    super();
  }

  findButtons() {
    this.atc = this.querySelector(".atc-button");
    this.atcPlaceholder = this.querySelector("#atc-placeholder");
    this.atcSpan = this.atc.querySelector("span");
    this.atcSpan.initialInnerHTML = this.atcSpan.innerHTML;

    this.container = document.querySelector(".mfp-wrap.mfp-quick-view") || window;

    this.atcPosition = new Position(this.atc, this.container);
    this.atcPlaceholderPosition = new Position(this.atcPlaceholder, this.container);
  }

  connectedCallback(){
    this.findButtons();
    this.atcHover();
    this.stickyATC();
    this.handleChange();
    this.afterLoad();
  }

  afterLoad() {
    window.addEventListener("load", () => {
      this.paypalHover();
      this.morePaymentOptionsHover();
      this.buyItNowHover();
    });
  }

  morePaymentOptionsHover(){
    this.morePaymentOptionsButton = this.querySelector("[class*='shopify-payment-button__more-options _2ogcW-Q9I-rgsSkNbRiJzA']");
    if(this.morePaymentOptionsButton) {
      this.morePaymentOptionsButton.innerHTML = "buy it now";
      this.morePaymentOptionsButton.initialInnerHTML = this.morePaymentOptionsButton.innerHTML;
      // this.morePaymentOptionsButton.initialInnerHTML = this.morePaymentOptionsButton.innerHTML = "buy it now";
      this.morePaymentOptionsButton.addEventListener("mouseover", () => {
        this.morePaymentOptionsButton.innerHTML = "♡ " + this.morePaymentOptionsButton.innerHTML + " ♡";
      });
      this.morePaymentOptionsButton.addEventListener("mouseout", () => {
        this.morePaymentOptionsButton.innerHTML = this.morePaymentOptionsButton.initialInnerHTML;
      });
    }
  }
  buyItNowHover() {
    this.buyItNowButton = this.querySelector("[class*='shopify-payment-button__button shopify-payment-button__button--unbranded _2ogcW-Q9I-rgsSkNbRiJzA _2EiMjnumZ6FVtlC7RViKtj _2-dUletcCZ2ZL1aaH0GXxT']");
    if(this.buyItNowButton) {
      this.buyItNowButton.initialInnerHTML = this.buyItNowButton.innerHTML;
      this.buyItNowButton.addEventListener("mouseover", () => {
        this.buyItNowButton.innerHTML = "♡ " + this.buyItNowButton.innerHTML + " ♡";
      });
      this.buyItNowButton.addEventListener("mouseout", () => {
        this.buyItNowButton.innerHTML = this.buyItNowButton.initialInnerHTML;
      });
    }
  }
  paypalHover() {
      // this.paypalButton = this.querySelector("[class='_1LP9NPTft85QosIXd3_zOV _3G6VJhJYno-AX3-X38f1TA _2EiMjnumZ6FVtlC7RViKtj _3DL4HVlgeOhG7Paj6K8DqS']");
      // if(this.paypalButton) {
      //   this.paypalButton.initialInnerHTML = this.paypalButton.innerHTML;
      //   this.paypalButton.addEventListener("mouseover", () => {
      //     var spans = this.paypalButton.getElementsByTagName("span");
      //     spans[1].innerHTML = "♡ " + spans[1].innerHTML;
      //     spans[spans.length - 1].innerHTML = spans[spans.length - 1].innerHTML + "  ♡";
      //   });
      //   this.paypalButton.addEventListener("mouseout", () => {
      //     this.paypalButton.innerHTML = this.paypalButton.initialInnerHTML;
      //   });
      // }
  }


  atcHover() {
    this.atc.addEventListener("mouseover", () => {
      this.atcSpan.innerHTML = ("♡  " + this.atcSpan.initialInnerHTML + "  ♡");
    });
    this.atc.addEventListener("mouseout", () => {
      this.atcSpan.innerHTML = this.atcSpan.initialInnerHTML;
    });
  }

  handleChange() {
    this.handleScroll();
    this.handleResize();
  }
  handleScroll() {
    this.container.addEventListener("scroll",() => {
      // console.log("===SCROLL EVENT===");
      this.stickyATC();
    });
  }

  handleResize() {
    this.container.addEventListener('resize', () => {
      // console.log("===RESIZE EVENT===");
      this.stickyATC();
      this.stickyATC();
    });
  }

  stickyATC() {
    if (this.atcPosition.outOfView) {
      this.atc.id = "sticky-atc";
      this.atcPlaceholder.classList.add("active");
      this.atcPlaceholderPosition.update();
      this.atcPosition.updateWithOther(this.atcPlaceholderPosition);
    }
    else {
      this.atc.id = "in-view";
      this.atcPlaceholder.classList.remove("active");
      this.atcPosition.update();
    }
    // console.log("######.2.######");
    // console.log("***ATC:***");
    // this.atcPosition.print();
    // console.log("***PLACEHOLDER:***");
    // // new Position(document.querySelector("#atc-placeholder"), this.container).print();
    // this.atcPlaceholderPosition.print();
  }

}

customElements.define("product-buttons", ProductButtons);